import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { ScaleValue } from '../../models/assessment.model';
import { SCALE_OPTIONS } from '../../data/assessment.seed';

export type ScaleOrientation = 'vertical' | 'horizontal';

@Component({
  selector: 'app-asmt-scale-picker',
  templateUrl: './scale-picker.component.html',
  styleUrls: ['./scale-picker.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ScalePickerComponent {
  @Input() value: ScaleValue | null = null;
  /** 'vertical' = one full-width row per option; 'horizontal' = five side-by-side cards. */
  @Input() orientation: ScaleOrientation = 'vertical';
  @Output() valueChange = new EventEmitter<ScaleValue>();
  options = SCALE_OPTIONS;
  pick(v: ScaleValue): void { this.valueChange.emit(v); }
}
